// src/app/link/guards/environment.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { RequirementsService } from '../requirements.service'; 

@Injectable({ providedIn: 'root' })
export class EnvironmentGuard implements CanActivate {
  constructor(private requirements: RequirementsService, private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
  
    if (!this.requirements.isChrome()) {
      console.warn('Acesso negado: Navegador não suportado.');
      return this.router.createUrlTree(['/link/unsupported-device'], { 
        queryParams: { reason: 'BROWSER_NOT_CHROME' } 
      });
    }

    const check = this.requirements.checkRequirements();
    if (!check.valid) {
      return this.router.createUrlTree(['/link/unsupported-device'], { 
        queryParams: { reason: check.reason } 
      });
    }

    return true; 
  }
}